module.exports = __webpack_public_path__ + "img/group-item_blue.e4be0a93.svg";